import React from "react";
import Select from "./Select";

const Input = ({ tag: Tag = "input", type = "text", className = "", multiselect = false, value, onChange, children, ...props } = {}) => {
    // Use custom Select component for all select elements
    if (Tag === "select") {
        return (
            <Select
                multiselect={multiselect}
                value={value}
                onChange={onChange}
                className={className}
                {...props}
            >
                {children} 
            </Select>
        );
    }

    // Standard behavior for non-select elements
    return (
        <Tag 
            type={type} 
            className={"font-degular w-full min-w-56 px-[33px] py-[13px] text-base font-medium leading-7 text-black !outline-none " + className} 
            {...(value !== undefined ? { value, onChange } : {})}
            {...props}
        >
            {children}
        </Tag>
    );
};

export default Input;
